import Box from '@mui/material/Box';
import { ComponentPropsWithoutRef, useMemo, useState } from 'react';
import { savePaymentConfigToStorage } from 'src/components/PaymentWidget/payment.storage';
import {
  PaymentData,
  PaymentWidgetTheme,
} from 'src/components/PaymentWidget/payment.type';
import { getPaymentWidgetConfig } from 'src/components/PaymentWidget/payment.util';
import usePaymentWidgetScriptLoader from 'src/components/PaymentWidget/usePaymentWidgetScriptLoader';
import { Skeleton } from 'src/components/Skeleton';
import { useMount } from 'src/helpers/hooks/useMount';

type Props = {
  theme?: Partial<PaymentWidgetTheme>;
  onTokenize: (data: PaymentData) => void;
  wrapperProps?: Omit<ComponentPropsWithoutRef<'div'>, 'children' | 'id'>;
};

function PaymentWidget({ theme, onTokenize, wrapperProps }: Props) {
  const [isSessionConfigSet, setIsSessionConfig] = useState(false);
  usePaymentWidgetScriptLoader({
    onTokenize,
    isReadyToLoadScript: isSessionConfigSet,
  });

  const paymentWidgetConfig = useMemo(
    () => getPaymentWidgetConfig(theme),
    [theme],
  );

  useMount(() => {
    setIsSessionConfig(false);
    savePaymentConfigToStorage(paymentWidgetConfig);
    setIsSessionConfig(true);
  });

  return (
    <>
      {isSessionConfigSet ? (
        <Box {...wrapperProps}>
          <div id="msiInsurance" />
        </Box>
      ) : (
        <Box {...wrapperProps}>
          <Skeleton />
        </Box>
      )}
    </>
  );
}

export default PaymentWidget;
